import React from "react";

import { Text } from "@/components/atoms/Text";

type BookingStepsItemProps = {
  title: string;
  description: string;
  stepNumber: number;
  visuallyConnectWithPrevStep: boolean;
};

const BookingStepsItem = ({
  stepNumber,
  title,
  description,
  visuallyConnectWithPrevStep,
}: BookingStepsItemProps) => {
  return (
    <>
      {/* Mobile vertical connector between steps */}
      {visuallyConnectWithPrevStep && (
        <div
          data-testid="step-connector"
          className="lg:tw-hidden tw-w-2 tw-h-64 tw-bg-brand-white"
          aria-hidden="true"
        />
      )}
      <div className="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-text-center">
        <div className="tw-relative tw-z-10 tw-w-[75px] tw-h-[75px] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-bg-brand-white tw-border">
          <Text
            element="span"
            typeface="headline-6-m"
            className="tw-text-purple-800"
          >
            {stepNumber}
          </Text>
        </div>
        <div className="lg:tw-mt-32 tw-mt-16 tw-flex tw-flex-col tw-gap-4">
          <Text
            element="p"
            typeface="headline-3-b"
            className="tw-text-brand-white"
          >
            {title}
          </Text>
          <Text element="p" typeface="body-2" className="tw-text-brand-white">
            {description}
          </Text>
        </div>
      </div>
    </>
  );
};

export { BookingStepsItem };
